@if (!hasChoices()) {
  <input type="text" class="w-100 form-control" (change)="onChanged()" (ngModelChange)="onModelChanged($event)" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
}
@if (hasChoices()) {
  <select class="w-100 form-select" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}" (change)="onChanged()">
    @for (choice of choices; track choice) {
      <option [value]="choice.value">{{ choice.label }}</option>
    }
  </select>
}
